{
  "el": {
    "choice": {
      "actions": {
        "delete_choice": "Διαγραφή επιλογής",
        "delete_choice_list": "Διαγραφή λίστας επιλογών"
      },
      "labels": {
        "not_selected": "Μη επιλεγμένο",
        "selected": "Επιλεγμένο"
      },
      "messages": {
        "delete_choice": "Θέλεις σίγουρα να διαγράψεις την επιλογή {title};",
        "delete_choice_list": "Θέλεις σίγουρα να αφαιρέσεις τη λίστα επιλογών {title};"
      },
      "toasts": {
        "create": "Η επιλογή δημιουργήθηκε με επιτυχία",
        "delete": "Η επιλογή διαγράφηκε με επιτυχία",
        "update": "Η επιλογή ενημερώθηκε με επιτυχία"
      }
    }
  }
}
